import {
  Message,
  MessageHeaderImage,
  MessageHeaderImagesCarousel,
  MessageTime,
} from '~/DesignSystem/components/messages'

type MessageProps = React.ComponentProps<typeof Message>

type IncomingImageMessageProps = {
  src?: string | string[]
  title?: string
  time: number
} & Omit<MessageProps, 'direction' | 'variant'> & {
    direction?: MessageProps['direction']
    variant?: MessageProps['variant']
  }

function IncomingImageMessage({
  src,
  title,
  time,
  children,
  direction = 'incoming',
  variant = 'secondary',
  ...props
}: IncomingImageMessageProps) {
  const images = Array.isArray(src) ? src : src ? [src] : undefined

  return (
    <Message direction={direction} variant={variant} {...props}>
      {!!images &&
        (images.length === 1 ? (
          <MessageHeaderImage src={images[0]} alt={title} />
        ) : (
          <MessageHeaderImagesCarousel images={images} alt={title} />
        ))}
      {children}
      <MessageTime>{time}</MessageTime>
    </Message>
  )
}

export { IncomingImageMessage }
